import React from "react";
import {StatisticsForSalesContainer} from '../../components/containers/StatisticsForSalesContainer';

export function SalesStatisticsPage() {
  return <StatisticsForSalesContainer />;
}
